






































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwNav, SwNavGroup, SwNavItem, SwNavSectionDivider } from '@libs-uuif/shared/sw-nav';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { CoreStoreState, SetNavCollapsedPayload, SetSupportCasesSliderVisiblePayload } from '@/core';
import { RootStoreState } from '@/store';
import { navService } from '@/shared/nav-service';
// import { currentUserKey } from '@/shared/msw-constants';
import { TabNavItem, NavNode, Node } from '@/shared/nav-service/types';
import { MswGuestOrMswLoginRoute } from '../../modules/msw-guestlogin-accountlogin';
// import { envCongif } from '@/shared/env.config';
// import  RedirectToContemparary  from '@/shared/redirect-to-contemparary.service';
// tslint:disable-next-line:no-unused
declare var feedbackWorkspace: Function;
const cssPrefix = 'msw-app-nav';

@Component({
  components: {
    SwNavGroup,
    SwNavItem,
    SwNavSectionDivider,
    SwNav,
    SwIcon,
  },
})
export default class MswAppNav extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  isArraySet:boolean = false;
  showFeedBackDialog: boolean = false;

  @State((state: RootStoreState) => state.CoreStoreModule.navCollapsed)
  navCollapsed: CoreStoreState['navCollapsed'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedTopTabItemId)
  selectedTopTabItemId: CoreStoreState['selectedTopTabItemId'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedNavItemId)
  selectedNavItemId: CoreStoreState['selectedNavItemId'];

  @Mutation
  selectNavItem: VuexMappedMutation<any>;

  @Mutation
  readonly setSupportCaseSliderVisible: VuexMappedMutation<SetSupportCasesSliderVisiblePayload>;

  @Mutation
  setNavCollapsed: VuexMappedMutation<SetNavCollapsedPayload>;
  navDataInit: TabNavItem[] = [];
  navData: NavNode = {
    navId: 'string',
    text: '',
    children: [],
  };
  navColor:string = '';

  onToggleNavCollapseTrigger() {
    this.setNavCollapsed({ collapse: !this.navCollapsed });
  }

  @Watch('isArraySet')
  private navDataUpdated() {
    if (this.navDataInit) {
      navService.initNavId(this.$router, this.$store);
      this.navData =    this.navDataInit[0].navTree;
      this.navColor = this.navDataInit[0].color;
    }
  }

  get isGuestBuyNow() {
    return this.$store.getters.isGuestBuyNowUser || false;
  }

  created() {
    let username = this.$store.getters.getUserId || '';
    if (this.isGuestBuyNow) {
      username = '';
    }
    this.$store.dispatch('getSideNavSiteMap', username)
        .then((response) => {
          if (response.operationStatus === 'OK') {
            const nodes:Node[] =  response.content.parentmenu;
            const tabs:NavNode[] = [];
            this.navDataInit = [];
            nodes.forEach((node) => {
              const childrenNodes:NavNode[] = [];
              node.children.forEach((childnode) => {
                childrenNodes.push({
                  navId: childnode.id,
                  icon: 'minus',
                  text: childnode.name,
                  route: this.url_path(childnode.id),
                });
              });
              tabs.push({
                navId : node.id,
                text : node.name,
                icon : node.icon.replace('icon-', ''),
                children: childrenNodes,
              });
            });
            const navTreeNode:NavNode = {
              navId: '__root',
              text: 'rootNode',
              children:tabs,
            };
            const dashNode:TabNavItem = {
              navId: 'Dashboard',
              color: '#fda348',
              icon: 'home',
              text: 'home',
              navTree: navTreeNode,
            };

            this.navDataInit.push(dashNode);
            this.isArraySet = navService.settabNavItems(this.navDataInit);
            // this.$store.commit('stopLoading');
          }
        });
  }
  // navigation to post it pages added when click on left nav
  mounted() {
    const anchorBall = document.getElementsByClassName('sw-nav-side-indicator')[0]! as HTMLElement;
    if (anchorBall) {
      anchorBall.style.top = '-20px';
    }
  }
  onSelectNavItem(navId: string) {
    if (true) {
      const url =  this.url_path(navId);
      const  hie = navService.searchNavNode(node => (!!node.route && this.matchRoute(url, node.route)));
      if (hie.tabItem && hie.tabItem.navId !== this.$store.state.CoreStoreModule.selectedTopTabItemId) {
        this.$store.commit({
          type: 'selectTopTabItem',
          navId: hie.tabItem.navId,
        });
      }
      if (hie.nodeHierarchy && hie.nodeHierarchy[hie.nodeHierarchy.length - 1].navId !== this.$store.state.CoreStoreModule.selectedNavItemId) {
        this.$store.commit({
          type: 'selectNavItem',
          navId: hie.nodeHierarchy[hie.nodeHierarchy.length - 1].navId,
        });
      }
    }
    if ((navId.includes('/knowledge-base-category'))) window.open(navId, '_blank');
    else if (navId.includes('/m/feature')) {
      const pathname = this.url_path(navId);
      if (navId.includes('/supportcases')) this.setSupportCaseSliderVisible({ visible: true });
      else this.$router.push({ path: pathname });
    } else {
      if (navId.includes('~/muir/login')) {
        this.checkIfguesbyUser(navId);
      } else {
        this.$store.dispatch('navigateTo', navId.replace('~/muir/', ''));
      }
    }
  }

  checkIfguesbyUser(route: string) {
    const isaccountmswredirectRow: any = localStorage.getItem('isaccountsmswredirect');
    const isaccountsmswredirect: string = (isaccountmswredirectRow && JSON.parse(isaccountmswredirectRow)) || 'NO';
    if (this.isGuestBuyNow && isaccountsmswredirect === 'YES') {
      this.$router.push({ path : `/m/${MswGuestOrMswLoginRoute.path}` });
    } else if (this.isGuestBuyNow && isaccountsmswredirect === 'NO') {
      this.$router.push({ path: '/m/login/login-view', query: { loginmode: 'guestbuynow' } });
    } else {
      this.$store.dispatch('navigateTo', route.replace('~/muir/', ''));
    }
  }

  url_domain(data:string) {
    const a  = document.createElement('a');
    a.href = data;
    return a.hostname;
  }
  matchRoute(fullPath: string, routePrefix: string): boolean {
    if (fullPath.indexOf(routePrefix) === 0) {
      const nextChar = fullPath.charAt(routePrefix.length);
      if (nextChar === '/' || nextChar === '?' || nextChar === '#' || !nextChar) {
        return true;
      }
    }
    return false;
  }
  url_path(data:string) {
    let replacedData = '';
    if (data.includes('~/muir/ui')) replacedData = data.replace('~/muir/ui/workspace', '');
    else replacedData = data.replace('~/workspace', '');
    return replacedData;
  }
  transformUrl(link:string) {
    return btoa(link);
  }
}
